import { Link } from "react-router-dom";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";

import { Handover } from "graphql/generated/graphql";
import { useLoggedUser } from "state/reactive-vars/logged-user-var";
import { OrganizationType, HandoverStatus } from "constants/field-values";
import routeNames from "constants/route-names";

interface HandoverSentProps {
	handover?: Pick<
		Handover,
		| "vendor_organization_id"
		| "vendor_organization"
		| "customer_organization_id"
		| "customer_organization"
		| "property"
		| "status"
	> | null;
}

const HandoverSent = ({ handover }: HandoverSentProps) => {
	const { loggedUserValue } = useLoggedUser();

	const loggedUserIsCustomer = loggedUserValue?.organization?.type === OrganizationType.Customer;

	return (
		<div className="ha-finished-card">
			<DotLottieReact
				src={`${process.env.PUBLIC_URL}/assets/images/lottie/checkmark-in-circle-pink.json`}
				autoplay
				style={{ width: "78px", height: "68px" }}
			/>
			<div>
				{loggedUserIsCustomer
					? handover?.status === HandoverStatus.PUBLISHED
						? "Handover accepted and published to property!"
						: `Your handover request has been sent to ${handover?.vendor_organization?.name || "the vendor"}. We'll notify you when it's ready for your review.`
					: `Your Handover has been sent to ${handover?.property?.name || "the property"} (${handover?.customer_organization?.name || "customer organization"})! We’ll let you know when they approve and publish!`}
			</div>
			<Link to={routeNames.HANDOVERS}>Back to Handovers</Link>
		</div>
	);
};

export default HandoverSent;
